module.exports = __webpack_public_path__ + "static/media/pistolContent.8ca515b0.png";